<template>
  <div class="content d-flex flex-wrap">
    <template v-for="(user, i) in avatarRenderData">
      <div :key="i" class="avatar-list-item">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-avatar class="pr-0 avatar" v-on="on">
              <v-gravatar
                :email="user.email"
                :class="{ avatar: true, small: !large }"
                :style="{
                  ...getBorderStyle(user._id, user.color),
                  ...(user.opacity !== 1 ? { filter: 'grayscale(100%)' } : {}),
                  'z-index': Math.trunc(user.opacity),
                }"
              />
            </v-avatar>
          </template>
          <span>{{ user.displayName }} - {{ user.email }}</span>
        </v-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import AvatarMixin from '../../mixins/avatar';

export default {
  mixins: [
    AvatarMixin,
  ],

  props: {
    userData: {
      type: Array,
      required: true,
    },
    large: Boolean,
  },

  computed: {
    avatarRenderData() {
      return _.sortBy(
        _.map(this.userData, data => {
          const user = this.getUser(data.id);
          return {
            id: _.get(user, '_id'),
            email: _.get(user, 'email'),
            displayName: _.get(user, 'displayName'),
            color: _.get(data, 'color'),
            opacity: _.get(data, 'opacity'),
          };
        }),
        i => -i.opacity
      );
    }
  },
};
</script>

<style scoped>
.content {
  width: 150px;
}
.avatar-list-item:nth-child(n + 2) {
  /* avatar "overlap" value */
  margin-left: -25px;
}
.avatar {
  margin: 0em .5em !important;
  width: 32px !important;
  min-width: 32px !important;
  height: 32px !important;
}
.avatar.small {
  width: 24px !important;
  min-width: 24px !important;
  height: 24px !important;
}
</style>
